import { render } from "./CreatePinGroupView.vue?vue&type=template&id=38dcef0f&scoped=true"
import script from "./CreatePinGroupView.vue?vue&type=script&lang=js"
export * from "./CreatePinGroupView.vue?vue&type=script&lang=js"

import "./CreatePinGroupView.vue?vue&type=style&index=0&id=38dcef0f&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dcef0f"]])

export default __exports__